<template>
  <div
    class="relative flex min-h-screen flex-col items-center justify-center overflow-hidden"
    :style="backgroundStyle"
    @mousemove="moveBackground"
  >
    <div
      class="absolute inset-0 z-0 bg-gradient-to-br from-blue-600/60 to-blue-900/90"
    ></div>

    <div
      class="relative z-10 flex w-full max-w-7xl flex-1 flex-col-reverse items-center justify-center gap-8 px-4 py-8 md:flex-row md:py-16"
    >
      <div
        class="flex w-full flex-1 items-center justify-center p-4 md:p-8 lg:p-12"
      >
        <transition name="fade-slide-left" mode="out-in">
          <component :is="currentView" class="w-full max-w-md" />
        </transition>
      </div>

      <div
        class="flex w-full flex-1 items-center justify-center p-4 md:p-8 lg:p-12 md:flex"
        :class="{
          hidden: isSmallScreen,
          'md:flex': !isSmallScreen,
        }"
      >
        <transition name="fade-slide-right" mode="out-in">
          <TextInitialComponent class="text-white" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  shallowRef,
} from 'vue'
import TextInitialComponent from '@/components/ui/TextInitialComponent.vue'
import WelcomeComponent from '@/components/ui/WelcomeComponent.vue'
import backgroundImage from '@/assets/images/crossed_lines.png'

const backgroundPosition = reactive({
  x: 5,
  y: 5,
})

const currentView = shallowRef(WelcomeComponent)
const screenWidth = ref(window.innerWidth)
const isSmallScreen = computed(() => screenWidth.value < 768)

const backgroundStyle = computed(() => ({
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: `${backgroundPosition.x}% ${backgroundPosition.y}%`,
  backgroundAttachment: 'fixed',
  backgroundColor: '#0c6dfc', // fallback color
}))

const moveBackground = (event) => {
  const { clientX, clientY } = event
  const x = (clientX / window.innerWidth - 0.5) * 20
  const y = (clientY / window.innerHeight - 0.5) * 20
  backgroundPosition.x = 50 + x
  backgroundPosition.y = 50 + y
}

const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth
}

onMounted(() => {
  window.addEventListener('resize', updateScreenWidth)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScreenWidth)
})
</script>

<style scoped>
.fade-slide-left-enter-active,
.fade-slide-left-leave-active,
.fade-slide-right-enter-active,
.fade-slide-right-leave-active {
  transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-slide-left-enter-from,
.fade-slide-left-leave-to {
  opacity: 0;
  transform: translateX(-50px);
}

.fade-slide-right-enter-from,
.fade-slide-right-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
</style>
